const BookingFooter = ({ companyName }) => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 py-6">
      <div className="container mx-auto px-4 text-center text-gray-500 text-sm">
        <p>© {new Date().getFullYear()} {companyName || "Good To Go Inspections"}. All rights reserved.</p>
      </div>
    </footer>
  );
};
export default BookingFooter;
